export interface NotificationModel {
  Code: string;
  Data: any; //JSON
  isNoRead?: boolean;
  id?: string;
}

export enum NotificationConnectionStatusEnum {
  NotificationDeviceConnected = "notification_status_connected",
  NotificationDeviceDisconnected = "notification_status_disconnected",
}

export enum NotificationDoorStateEnum {
  NotificationDoorState = "notification_door_state",
}

export enum NotificationLockStateEnum {
  NotificationLockState = "notification_lock_state",
}

export enum NotificationFaceEnrollmentResult {
  NotificationFaceEnrollmentResult = "notification_face_enrollment_result",
}

export enum NotificationAccessLogs {
  NotificationAccessLogs = "notification_access_log",
}

export enum NotificationNetworkSettings {
  success = "device_network_settings_success",
  failure = "device_network_settings_failure",
}

export enum NotificationFirmwareUpdate {
  NotificationFirmwareUpdate = "notification_firmware_upgrade",
}

export enum NotificationDatetimeResponse {
  NotificationDatetimeResponse = "notification_datetime_response",
}

export enum NotificationDiagnostic {
  NotificationDiagnostic = "notification_diagnostic_data_response",
}

export enum NotificacionDeviceEdgeLogsEnum {
  NotificacionDeviceEdgeLogs = "device_edge_logs_response",
}

export enum NotificationDeviceConnectionSpeedTestResponse {
  NotificationDeviceConnectionSpeedTestResponse = "notification_device_connection_speed_test_response",
}

export enum NotificationDevicePowerCheckResponse {
  NotificationDevicePowerCheckResponse = "notification_device_power_check_response",
}

export interface NotificationFaceEnrollmentResultDataModel {
  fullName: string;
  userId: string;
  success: boolean;
  failureReason:
    | "None"
    | "Unknown"
    | "TimedOut"
    | "Cancelled"
    | "FaceAlreadyEnrolled"
    | "NoFacesInImage"
    | "TooManyFacesInImage"
    | "FaceTooClose"
    | "FaceTooFar"
    | "FaceNotStraightForward"
    | "CardAlreadyEnrolled"
    | "FacilityCodeNotAllowed"
    | "CardFormatNotAllowed";
}

export enum FailureReasonType {
  None = 0,
  Unknown = 1,
  TimedOut = 2,
  Cancelled = 3,
  FaceAlreadyEnrolled = 4,
  NoFacesInImage = 5,
  TooManyFacesInImage = 6,
  FaceTooClose = 7,
  FaceTooFar = 8,
  FaceNotStraightForward = 9,
  CardAlreadyEnrolled = 10,
  CardFormatNotAllowed = 11,
  FacilityCodeNotAllowed = 12,
}

export const FirestorePathRoute = {
  Devices: {
    Index: "Devices",
    AccessLog: "AccessLog",
    ConnectionStatus: "ConnectionStatus",
    DoorState: "DoorState",
    LockState: "LockState",
    NetworkSettings: "NetworkSettings",
    EdgeLogsResponse: "EdgeLogsResponse",
  },
  Users: {
    Index: "Users",
    FaceEnrollmentResult: "FaceEnrollmentResult",
    CardEnrollmentResult: "CardEnrollmentResult",
  },
  AccountSupport: {
    Index: "AccountSupport",
    FirmwareUpgrade: "FirmwareUpgrade",
    DateTimeSettings: "DateTimeSettings",
    DiagnosticData: "DiagnosticData",
    DeviceConnectionSpeedTest: "DeviceConnectionSpeedTest",
    DevicePowerCheck: "DevicePowerCheck",
  },
};

export enum CustomNotificationType {
  ScheduledMaintenance = 26,
  FirmwareUpgradeStart = 27,
  FeatureRelease = 28,
  PlannedOutageStart = 29,
  ScheduledMaintenanceComplete = 30,
  FirmwareUpgradeComplete = 31,
  PlannedOutageEnd = 32,
}

export interface INotificationTypeOption {
  value: CustomNotificationType;
  label: string;
  description: string;
}
